<template>
  <div class="Minister-top productborder margin-top1 uploadPictures">
    <div class="Minister-top-top productbackground">
      <div class="Minister-top-left product-top-color">产品安全法规图片</div>
    </div>
    <div class="productimgs">
      <div class="fluid container">
        <draggable class="list-group" tag="ul" @start="isDragging = true" @end="isDragging = false"
          :list="imgListSelect" handle=".list-group-item">
          <li class="list-group-item" v-for="(element, index) in imgListSelect" :key="element">
            <div class="mask">
              <i class="custom-icon el-icon-zoom-in" @click="handlePictureCardPreview(element)"></i>
              <i class="custom-icon el-icon-delete" @click="handleRemoveSelect(index)"></i>
            </div>
            <div class="badge">
              <img :src="element" alt />
            </div>
          </li>
          <li @click="dialogVisibleSelect = true" class="avatar-uploader" slot="footer">
            <i data-v-c660ac10 class="el-icon-plus"></i>
          </li>
        </draggable>
      </div>

      <el-row type="flex" align="middle" style="margin-top:10px;">
        <template v-if="pageType === 'download'">
          <el-button type="primary" @click="downloadImgs" style="margin-right:10px;">批量下载
          </el-button>
        </template>
        <p>
          图片可批量上传，只支持
          <span style="color:red;font-weight:bold;">GPSR图片
          </span>
          。
        </p>
      </el-row>
      <el-dialog :visible.sync="dialogVisibleSelect" width="1200px">
        <div slot="title" class="dialog-select-img">
          <div class="title-box">选择图片</div>
          <el-button type="primary" @click="linkImgDialog = true">使用网络图片</el-button>
        </div>
        <draggable class="list-group" tag="ul" @start="isDragging = true" @end="isDragging = false"
          :list="imgListUpdate" handle=".list-group-item">
          <li class="list-group-item" v-for="(element, index) in imgListUpdate" :key="element.url">
            <div class="mask">
              <i class="custom-icon el-icon-zoom-in" @click="handlePictureCardPreview(element)"></i>
              <i class="custom-icon el-icon-delete" @click="handleRemoveSelect2(index)"></i>
            </div>
            <div class="badge">
              <img :src="element.url" alt />
            </div>
          </li>
          <el-upload class="upload-demo" ref="dialogSelect" accept="image/jpeg, image/tiff, image/png" drag multiple
            :action="action" list-type="picture-card" :on-success="handSuccess" :on-change="handChange"
            :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-error="handleError"
            :on-progress="handleProgress" :headers="customHeaders" :auto-upload="false" :http-request="customUpload">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>选择图片</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传GPSR图片，且不超过2M
            </div>
          </el-upload>
        </draggable>
        <div v-if="isUploading" style="margin-top:20px">
          <el-progress :percentage="uploadProgress"></el-progress>
          <div style="text-align:center; margin-top:5px;">正在上传... ({{ pendingUploadFiles.length }} 个文件)</div>
        </div>
        <!-- <div style="margin-top:20px">
          <el-button type="primary" @click="submitUpload"
            >点击上传</el-button
          >
        </div> -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleSelect = false">取 消</el-button>
          <el-button type="primary" @click="sureImg">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="linkImgDialog">
        <div slot="title" class="dialog-select-img">
          <div class="title-box">使用网络图片</div>
          <el-button type="primary" @click="uploadLinkImg">上传</el-button>
        </div>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入图片地址，多个图片地址请用换行分隔"
          v-model="textarea">
        </el-input>
      </el-dialog>
      <el-dialog :visible.sync="dialogVisibleSee" width="500px">
        <img width="100%" :src="dialogImageUrl" alt />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { ajaxPost, Baseurl } from '../../../../api/api/api'
import Axios from "axios";
export default {
  components: {
    draggable,
  },
  props: {
    pageType: {
      type: String,
      default() {
        return ''
      },
    },
  },
  data() {
    return {
      action: Baseurl + 'xgImage/uploadImage',
      dialogVisibleSelect: false,
      dialogVisibleSee: false,
      dialogImageUrl: '',
      imgList: '',
      imgListUpdate: [],
      imgListSelect: [],
      isDragging: false,
      customHeaders: { token: localStorage.getItem('token') },
      updateImageList: [],
      arr: [],
      linkImgDialog: false,
      textarea: '',
      pendingUploadFiles: [], // 待上传的文件列表
      isUploading: false, // 是否正在上传
      uploadProgress: 0, // 上传进度
      uploadStatus: '', // 上传状态
      currentUploadIndex: 0, // 当前上传第几个文件
      uploadTimer: null, // 上传定时器
    }
  },
  methods: {
    async uploadLinkImg() {
      const urls = this.textarea
        .split('\n')
        .map(item => item.trim())
        .filter(item => item);

      if (urls.length === 0) {
        this.$message.error('请输入图片地址');
        return;
      }

      this.updImageState = true;

      try {
        let urls = this.textarea
          .split('\n')
          .map(item => item.trim())
          .filter(item => item);
        urls = urls.map((item) => {
          return {
            url: item,
            response: {
              data: item,
            },
          }
        })
        // ⬇️ 顺序 = urls 顺序
        const res1 = [...this.imgListUpdate, ...urls];
        this.imgListUpdate = res1;
        this.imgList = this.imgListUpdate.map((item) => item.response && item.response.data)
        this.$message.success('上传成功')
        this.linkImgDialog = false;
        this.textarea = '';
        this.arr = true;
      } catch (e) {
        this.$message.error('图片上传过程中出现异常');
      } finally {
        this.updImageState = false;
      }

    },
    addImgList(imgArr) {
      this.imgListSelect = imgArr
      this.$emit('ImgList', this.imgListSelect)
    },
    // 父组件添加图片相应
    addImg(file) {
      this.imgListSelect.push(file)
      this.$emit('ImgList', this.imgListSelect)
    },
    sureImg() {
      // 如果有文件正在上传或待上传,先执行上传
      if (this.pendingUploadFiles.length > 0 && !this.isUploading) {
        this.$message.warning('请先等待文件上传完成');
        return;
      }

      if (this.isUploading) {
        this.$message.warning("文件正在上传中,请稍候");
        return;
      }

      // 上传完成后,将图片添加到选择列表
      if (this.imgListUpdate.length > 0) {
        // 按照 imgListUpdate 的顺序生成最终列表
        const newImages = this.imgListUpdate
          .filter((item) => item.response && item.response.data)
          .map((item) => item.response.data);

        this.imgListSelect = [...this.imgListSelect, ...newImages];
        this.imgListUpdate = [];
        this.$refs.dialogSelect && this.$refs.dialogSelect.clearFiles();
        this.dialogVisibleSelect = false;
        this.$emit("ImgList", this.imgListSelect);
      } else {
        // 如果没有新上传的文件,直接关闭对话框
        this.dialogVisibleSelect = false;
      }
    },
    handleProgress(event, file, fileList) {
      // console.log(event)
    },
    handChange(file, fileList) {
      // 清除之前的定时器
      if (this.uploadTimer) {
        clearTimeout(this.uploadTimer);
      }

      // 收集待上传的文件,不自动上传
      // 过滤出还没上传过的文件(没有 response 或者 status 不是 success)
      this.pendingUploadFiles = fileList.filter(
        (f) => !f.response || f.status !== "success",
      );
      // 按文件名升序排序
      this.pendingUploadFiles.sort((a, b) => {
        return a.name.localeCompare(b.name, "zh-CN", { numeric: true });
      });

      // 延迟500ms后自动开始上传(等待所有文件选择完成)
      this.uploadTimer = setTimeout(() => {
        this.startSequentialUpload();
      }, 500);
    },
    // 压缩图片
    compressImage(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.raw || file);
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            // 设置画布尺寸
            canvas.width = img.width;
            canvas.height = img.height;

            // 绘制图片
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            // 将 canvas 转换为 Blob,JPEG 质量 0.85
            canvas.toBlob(
              (blob) => {
                if (blob) {
                  // 创建新的 File 对象
                  const compressedFile = new File(
                    [blob],
                    file.name.replace(/\.[^/.]+$/, ".jpg"),
                    {
                      type: "image/jpeg",
                      lastModified: Date.now(),
                    },
                  );
                  resolve(compressedFile);
                } else {
                  // 如果压缩失败,返回原文件
                  resolve(file.raw || file);
                }
              },
              "image/jpeg",
              0.85,
            );
          };
          img.onerror = (error) => {
            console.error("图片加载失败:", error);
            resolve(file.raw || file);
          };
        };
        reader.onerror = (error) => {
          console.error("文件读取失败:", error);
          reject(error);
        };
      });
    },
    // 自定义上传方法,阻止默认上传行为
    customUpload() {
      // 阻止默认上传,我们会手动控制上传流程
      return Promise.resolve();
    },
    // 开始并发上传
    async startSequentialUpload() {
      if (this.pendingUploadFiles.length === 0) {
        this.$message.warning("请先选择要上传的文件");
        return;
      }

      if (this.isUploading) {
        return;
      }

      this.isUploading = true;
      this.uploadStatus = "";
      const uploadPromises = [];

      // 并发上传所有文件
      for (let i = 0; i < this.pendingUploadFiles.length; i++) {
        const file = this.pendingUploadFiles[i];
        const index = i; // 保存原始索引

        // 创建上传任务
        const uploadPromise = (async () => {
          try {
            // 先压缩图片
            const compressedFile = await this.compressImage(file);

            // 手动上传文件
            const formData = new FormData();
            formData.append("file", compressedFile);

            const response = await Axios({
              url: this.action,
              method: "post",
              data: formData,
              headers: {
                "Content-Type": "multipart/form-data",
                token: localStorage.getItem("token"),
              },
            });

            if (response.data.code === 200) {
              // 上传成功
              file.status = "success";
              file.response = response.data;

              const item = {
                url: response.data.data,
                response: {
                  data: response.data.data,
                },
                originalIndex: index, // 保存原始索引
              };

              return { success: true, item, index };
            } else {
              // 上传失败
              file.status = "fail";
              this.$message.error(
                `${file.name} 上传失败: ${response.data.message || "未知错误"}`,
              );
              return {
                success: false,
                index,
                error: response.data.message || "未知错误",
              };
            }
          } catch (error) {
            // 上传异常
            console.error("上传异常:", error);
            file.status = "fail";
            this.$message.error(
              `${file.name} 上传失败: ${error.message || "网络错误"}`,
            );
            return {
              success: false,
              index,
              error: error.message || "网络错误",
            };
          }
        })();

        uploadPromises.push(uploadPromise);
      }

      // 等待所有上传完成
      try {
        const results = await Promise.all(uploadPromises);

        // 按照原始索引排序结果
        const successResults = results
          .filter((r) => r.success)
          .sort((a, b) => a.index - b.index);

        // 添加到 imgListUpdate (已按排序后的顺序)
        successResults.forEach((result) => {
          this.imgListUpdate.push(result.item);
        });

        // 所有文件上传完成
        this.uploadProgress = 100;
        const allSuccess =
          successResults.length === this.pendingUploadFiles.length;
        const failCount =
          this.pendingUploadFiles.length - successResults.length;

        // 修复:只在有成功或失败时设置status
        if (successResults.length > 0) {
          this.uploadStatus = allSuccess ? "success" : "exception";
        } else {
          this.uploadStatus = "";
        }

        this.isUploading = false;
        this.pendingUploadFiles = [];
        this.$refs.dialogSelect.clearFiles();

        if (allSuccess && successResults.length > 0) {
          this.arr = true;
          this.imgList = this.imgListUpdate.map(
            (item) => item.response && item.response.data,
          );
          this.$message.success(
            `所有文件上传完成! 共 ${successResults.length} 个文件`,
          );
        } else if (successResults.length > 0) {
          // 部分文件上传成功
          this.arr = true;
          this.imgList = this.imgListUpdate.map(
            (item) => item.response && item.response.data,
          );
          this.$notify({
            title: "上传完成",
            message: `成功: ${successResults.length} 个, 失败: ${failCount} 个`,
            type: "warning",
            duration: 5000,
          });
        } else if (failCount > 0) {
          // 所有文件都失败
          this.$notify.error({
            title: "上传失败",
            message: `${failCount} 个文件上传失败,请检查网络或文件格式后重试`,
            duration: 5000,
          });
        }
      } catch (error) {
        console.error("上传过程出错:", error);
        this.isUploading = false;
        this.uploadStatus = "exception";
        this.$message.error("上传过程出现异常");
      }
    },
    handleAvatarSuccess(response, file, fileList) {
      this.$message.success('上传成功')
      this.imgListUpdate = fileList
    },
    uploading(msg) {
      this.$message.success(msg)
    },
    handleError(err, file, fileList) {
      this.$message.error(err)
      // console.log(err)
    },
    handSuccess(res, file, fileList) {
      // 保留空方法以兼容旧代码
    },
    handlePictureCardPreview(file) {
      let imageUrl = ''
      if (Object.prototype.toString.call(file) === '[object Object]') {
        imageUrl = file.response.data
      } else {
        imageUrl = file
      }
      this.dialogImageUrl = imageUrl
      this.dialogVisibleSee = true
    },
    handleRemove(file, fileList) {
      this.imgListUpdate = fileList
    },
    handleRemoveSelect(index) {
      this.$nextTick(() => {
        let imgInfo = this.imgListSelect[index]
        let deleteImage = (imgInfo.lastIndexOf('/') + 1)
        deleteImage = imgInfo.substring(deleteImage, imgInfo.length)
        let deleteFiles = []
        deleteFiles.push(deleteImage)
        this.imgListSelect.splice(index, 1)
        // let API = Baseurl + 'xgImage/deleteImage'
        // ajaxPost(API, { objectNames: deleteFiles })
        //   .then((res) => {
        //     if (res.data.code == 200) {
        //       this.$message.success('删除图片成功!')
        //     } else {
        //       this.$message.error(res.data.data || '删除图片失败!')
        //     }
        //   })
        //   .catch((e) => {
        //     console.log(e)
        //   })
        deleteFiles = []
      })
    },
    handleRemoveSelect2(index) {
      this.$nextTick(() => {
        let imgInfo = this.imgListUpdate[index].response.data
        let deleteImage = (imgInfo.lastIndexOf('/') + 1)
        deleteImage = imgInfo.substring(deleteImage, imgInfo.length)
        let deleteFiles = []
        deleteFiles.push(deleteImage)
        this.imgListUpdate.splice(index, 1)
        // let API = Baseurl + 'xgImage/deleteImage'
        // ajaxPost(API, { objectNames: deleteFiles })
        //   .then((res) => {
        //     if (res.data.code == 200) {
        //       this.$message.success('删除图片成功!')
        //     } else {
        //       this.$message.error(res.data.data || '删除图片失败!')
        //     }
        //   })
        //   .catch((e) => {
        //     console.log(e)
        //   })
        deleteFiles = []
      })
    },
    downloadImgs() {
      this.$emit('downloadImgs')
    },
  },
  beforeDestroy() {
    // 清除定时器
    if (this.uploadTimer) {
      clearTimeout(this.uploadTimer);
    }
  },
}
</script>

<style lang="scss" scoped>
.uploadPictures {
  /deep/ .el-upload-list__item {
    width: 178px;
    height: 178px;
  }

  /deep/ .el-upload--picture-card {
    width: 178px;
    height: 178px;
    line-height: 178px;
    padding: 0 20px;
  }

  /deep/ .selectUpload {
    // .el-upload.el-upload--picture-card,
    .el-upload-list__item-status-label {
      display: none;
    }
  }

  /deep/ .upload-demo {
    .el-upload-list--picture-card.el-upload-list {
      display: none;
    }

    .el-upload--picture-card {
      line-height: initial;

      .el-upload-dragger {
        width: 100%;
        height: 100%;
        border: none;
      }
    }
  }

  /deep/ .el-dialog__body {
    word-break: break-word;
  }

  .flip-list-move {
    transition: transform 0.5s;
  }

  .no-move {
    transition: transform 0s;
  }

  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }

  .list-group {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;

    .list-group-item {
      width: 178px;
      height: 178px;
      background-color: #fbfdff;
      border: 1px dashed #c0ccda;
      border-radius: 6px;
      box-sizing: border-box;
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 10px;
      // float: left;
      position: relative;
      overflow: hidden;

      .mask {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        transition-duration: 0.5s;

        .custom-icon {
          font-size: 20px;
          margin: 0 8px;
          color: #fff;
        }
      }

      &:hover .mask {
        opacity: 1;
        border-color: #409eff;
      }
    }

    .list-group-item img {
      width: 100%;
      height: 100%;
    }
  }

  .showImg {
    width: 148px;
    float: left;
    margin-right: 15px;
  }

  .avatar-uploader {
    width: 178px;
    height: 178px;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    text-align: center;
    line-height: 178px;
    font-size: 40px;

    &:hover {
      border-color: #409eff;
    }
  }
}
.dialog-select-img{
		display: flex;
		align-items: center;
		.title-box{
			font-size: 18px;
			margin-right: 10px;
		}
	}
</style>
